export default "__VITE_ASSET__DTD7HfOe__"